import { render } from "./footer.vue?vue&type=template&id=2e1b239e&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts&scoped=true"
export * from "./footer.vue?vue&type=script&lang=ts&scoped=true"

import "./footer.vue?vue&type=style&index=0&id=2e1b239e&lang=less&scoped=true"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1b239e"]])

export default __exports__